import { createRoute, Outlet, useSearch } from '@tanstack/react-router'
import { z } from 'zod'

import { ContactDetail } from '../pages'
import { contactRoute } from './ContactRoute'

const contactDetailRouteSearch = z.object({
  skip: z.boolean().optional()
})

export const contactDetailRoute = createRoute({
  getParentRoute: () => contactRoute,
  validateSearch: (search) => contactDetailRouteSearch.parse(search),
  component: function RouteWrapper() {
    const searchParams = useSearch({ from: '/main-layout/contact/$id' })
    const skip = searchParams.skip as z.infer<typeof contactDetailRouteSearch>['skip']
    const showDetail = typeof skip === 'undefined'

    return (
      <>
        {showDetail && <ContactDetail />}
        <Outlet />
      </>
    )
  },
  path: '/$id'
})
